import { Component } from '@angular/core';
import { ModalService } from '../../../../../../../coverpath-common/angular/services/modal/modal.service';
import { AmorphicService } from '../../../../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { Agent } from '../../../../../../../common/js/customer/Agent';

@Component({
  selector: 'convert-policy',
  moduleId: module.id,
  templateUrl: './convert-policy.component.html',
})
export class ConvertPolicyComponent {
  servicingAgent: Agent;

  constructor(private amorphicService: AmorphicService, private modalService: ModalService) {
    this.servicingAgent = amorphicService.controller.customer.application.primaryPolicy.servicingAgent;
  }

  closeModal(): void {
    this.modalService.deactivate();
  }
}
